var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('xyz-transition',{attrs:{"appear":"","xyz":"down-100%"}},[_c('nav',{directives:[{name:"random-bg",rawName:"v-random-bg"}],staticClass:"page-nav__wrap patterned-bg bg-75 xyz-out-nested",attrs:{"role":"navigation"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }